import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import {
  MailerDomainsList,
  MailerDomainsListSuccess,
  MailerDomainsListError,
  MailerDomainDelete,
  MailerDomainDeleteSuccess,
  MailerDomainDeleteError,
  MailerDomainCreate,
  MailerDomainCreateSuccess,
  MailerDomainCreateError,
  MailerDomainUpdate,
  MailerDomainUpdateSuccess,
  MailerDomainUpdateError,
} from '@app/stores/mailer-domain/mailer-domain.actions';
import {IMailerDomainState} from '@app/stores/mailer-domain/mailer-domain.state';
import {MailerDomainService} from '@app/services/mailer-domain.service';

@Injectable()
export class MailerDomainEffects {
  private _actions$ = inject(Actions);
  private _store = inject<Store<IMailerDomainState>>(Store);
  private mailerDomainService = inject(MailerDomainService);
  private loaderService = inject(LoaderService);


  mailerDomainsList$ = createEffect(() => this._actions$.pipe(
    ofType(MailerDomainsList),
    switchMap((action) => {
      this.loaderService.show();
      return this.mailerDomainService.getMailerDomains(action.params).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return MailerDomainsListSuccess({paginatedMailerDomains: resp.data});
          }
          this.loaderService.hide(true);
          return MailerDomainsListError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(MailerDomainsListError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));

  mailerDomainDelete$ = createEffect(() => this._actions$.pipe(
    ofType(MailerDomainDelete),
    switchMap((action) => {
      this.loaderService.show();
      return this.mailerDomainService.deleteMailerDomain(action.mailerDomainId).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return MailerDomainDeleteSuccess();
          }
          this.loaderService.hide(true);
          return MailerDomainDeleteError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(MailerDomainDeleteError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));

  mailerDomainCreate$ = createEffect(() => this._actions$.pipe(
    ofType(MailerDomainCreate),
    switchMap((action) => {
      this.loaderService.show();
      return this.mailerDomainService.addMailerDomain(action.mailerDomain).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return MailerDomainCreateSuccess();
          }
          this.loaderService.hide(true);
          return MailerDomainCreateError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(MailerDomainCreateError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));

  mailerDomainUpdate$ = createEffect(() => this._actions$.pipe(
    ofType(MailerDomainUpdate),
    switchMap((action) => {
      this.loaderService.show();
      return this.mailerDomainService.updateMailerDomain(action.mailerDomainId, action.mailerDomain).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return MailerDomainUpdateSuccess();
          }
          this.loaderService.hide(true);
          return MailerDomainUpdateError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(MailerDomainUpdateError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));
}
